import type { AdminPageAccessRule } from '../../registry.ts';

/**
 * Хто бачить сторінку `notifications`: у перший екран їде лише це (опис і код — у `page.ts`). Ключ —
 * літералом, як у сусідніх сторінках: імпорт `NOTIFICATIONS_MANAGE_PERMISSION` з контрактів потягнув
 * би zod у перший екран.
 */
export default {
  group: 'company',
  permission: 'notifications.manage',
} satisfies AdminPageAccessRule;
